/**
 * @file    IFramePage.jsx
 *
 * @author  Bryan Hoang <bryan@distributive.network>
 * @date    Sept. 2024
 */

import { useLocation } from 'react-router-dom';

import { Layout } from '@/components/Layout';

/**
 * Renders a page that uses an iframe for its content.
 */
export function IFramePage(_props)
{
  var cacheKey;
  const location = useLocation();
  const page = location.pathname.split('/')[1];
  const { VITE_GIT_REV } = import.meta.env;
  const build = dcp['dcp-build'];

  /* Cache strategy: in production, the page gets refreshed every time there is a new version of the
   * repo installed. In dev, we do this but also add the offset since the last SPA reload to the cache
   * key.
   */
  if (build.config.build === 'debug')
    cacheKey = VITE_GIT_REV + '-' + build.version + '-' + Math.floor((Date.now() - performance.now()) / 500);
  else
    cacheKey = VITE_GIT_REV + '-' + build.version;

  return (
    <Layout contentClassName={page}>
      <iframe src={`/${page}/index.html?cacheKey=${cacheKey}`} title={`Main content for /${page}`} allow="fullscreen"/>
    </Layout>
  );
}
